<template>
    <section class="content">
      <box>
        <div slot="body">
            <div class="row">
                <div class="col-md-6">
                    <h4>Nome</h4>
                    <input v-model="nome" type="text" class="form-control" >
                </div>
            </div>
            <br>
            <!--    SUBNIVEL   -->
            <!--<div class="row">
              <div class="col-md-12">
                <label class="btn btn-secondary">
                  <input type="checkbox" v-model="subnivel" > Cadastrar como Subnivel
                </label>
              </div>
            </div>
            <div class="row" v-show="subnivel" >
              <div class="col-md-12">
              <h4>Categoria Pai</h4>
                <select class="form-control" v-model="categoria_pai">
                    <option v-for="c in categories" v-bind:value="c.id">{{c.id}} - {{c.nome}}</option>
                </select>
              </div>
            </div>-->
            <br><br>
            <router-link class="pageLink" to="/condpagto">
                    <button class="btn btn-danger" >Cancelar</button>
            </router-link>
            <button class="btn btn-success" @click="gravar" v-show="nome!='' && !gravando"><i class="fa fa-check"></i>  Gravar</button>
            <button v-show="gravando" class="btn btn-success"><i class="fa fa-spinner fa-spin"></i>  Gravando</button>
        </div>
    </box>
        
    </section>
</template>
<script>
import axios from 'axios'
import Box from './Box' // importando modal

export default {
  name: 'NovaCondPagto',
  components: {
    'box': Box
  },
  data () {
    return {
      nome: '',
      gravando: false,
    }
  },
  created () {
  },
  methods: {
    gravar () {
      this.gravando = true
      axios.post(this.$store.state.api+'pagamentos/insert', {
        'nome': this.nome
      }).then(response => {
          if (response.data.success === 'true') {
            this.$swal({
                    position: 'top-end',
                    type: 'success',
                    title: 'Condição de Pagamento criada com sucesso',
                    showConfirmButton: false,
                    timer: 1500
                  })   
            this.$router.push('condpagto')
              
            
          } else {
            this.$swal(
              'Ops!',
              'A categoria não foi gravada.',
              'error'
            )
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// NovaCondPagto.vue?357c4b04